export default __webpack_public_path__ + "static/media/start-k-9.bab1099f.jpg";